import baseCreate from './_baseCreate.js';
import baseLodash from './_baseLodash.js';

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

export default LodashWrapper;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_LodashWrapper.js
// module id = 110
// module chunks = 0